export default "/static/dashboard/build/app/img/v2/a61a814f7964e0688cf232a54a0e69da.png";